const startingState = {
  "date": "2022-06-10",
  "date_epoch": 1654819200,
  "day": {
      "maxtemp_c": 45.6,
      "maxtemp_f": 114.1,
      "mintemp_c": 27.6,
      "mintemp_f": 81.7,
      "avgtemp_c": 35.7,
      "avgtemp_f": 96.3,
      "maxwind_mph": 15.9,
      "maxwind_kph": 25.6,
      "totalprecip_mm": 0,
      "totalprecip_in": 0,
      "avgvis_km": 10,
      "avgvis_miles": 6,
      "avghumidity": 16,
      "daily_will_it_rain": 0,
      "daily_chance_of_rain": 0,
      "daily_will_it_snow": 0,
      "daily_chance_of_snow": 0,
      "condition": {
          "text": "Sunny",
          "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
          "code": 1000
      },
      "uv": 11
  },
  "astro": {
      "sunrise": "05:19 AM",
      "sunset": "07:27 PM",
      "moonrise": "02:56 PM",
      "moonset": "02:06 AM",
      "moon_phase": "Waxing Gibbous",
      "moon_illumination": "77"
  },
  "hour": [
      {
          "time_epoch": 1654799400,
          "time": "2022-06-10 00:00",
          "temp_c": 29,
          "temp_f": 84.2,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 5.1,
          "wind_kph": 8.3,
          "wind_degree": 69,
          "wind_dir": "ENE",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 19,
          "cloud": 15,
          "feelslike_c": 26.9,
          "feelslike_f": 80.4,
          "windchill_c": 29,
          "windchill_f": 84.2,
          "heatindex_c": 26.9,
          "heatindex_f": 80.4,
          "dewpoint_c": 3.1,
          "dewpoint_f": 37.6,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 10.7,
          "gust_kph": 17.3,
          "uv": 1
      },
      {
          "time_epoch": 1654803000,
          "time": "2022-06-10 01:00",
          "temp_c": 28.9,
          "temp_f": 84,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 6.5,
          "wind_kph": 10.4,
          "wind_degree": 70,
          "wind_dir": "ENE",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 21,
          "cloud": 10,
          "feelslike_c": 26.9,
          "feelslike_f": 80.4,
          "windchill_c": 28.9,
          "windchill_f": 84,
          "heatindex_c": 26.9,
          "heatindex_f": 80.4,
          "dewpoint_c": 4.4,
          "dewpoint_f": 39.9,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 13.6,
          "gust_kph": 22,
          "uv": 1
      },
      {
          "time_epoch": 1654806600,
          "time": "2022-06-10 02:00",
          "temp_c": 28.8,
          "temp_f": 83.8,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 6.5,
          "wind_kph": 10.4,
          "wind_degree": 63,
          "wind_dir": "ENE",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 22,
          "cloud": 7,
          "feelslike_c": 26.9,
          "feelslike_f": 80.4,
          "windchill_c": 28.8,
          "windchill_f": 83.8,
          "heatindex_c": 26.9,
          "heatindex_f": 80.4,
          "dewpoint_c": 5,
          "dewpoint_f": 41,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 13.6,
          "gust_kph": 22,
          "uv": 1
      },
      {
          "time_epoch": 1654810200,
          "time": "2022-06-10 03:00",
          "temp_c": 28.5,
          "temp_f": 83.3,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 6.9,
          "wind_kph": 11.2,
          "wind_degree": 66,
          "wind_dir": "ENE",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 23,
          "cloud": 5,
          "feelslike_c": 26.7,
          "feelslike_f": 80.1,
          "windchill_c": 28.5,
          "windchill_f": 83.3,
          "heatindex_c": 26.7,
          "heatindex_f": 80.1,
          "dewpoint_c": 5.1,
          "dewpoint_f": 41.2,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 14.5,
          "gust_kph": 23.4,
          "uv": 1
      },
      {
          "time_epoch": 1654813800,
          "time": "2022-06-10 04:00",
          "temp_c": 28,
          "temp_f": 82.4,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 6.7,
          "wind_kph": 10.8,
          "wind_degree": 66,
          "wind_dir": "ENE",
          "pressure_mb": 998,
          "pressure_in": 29.48,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 23,
          "cloud": 7,
          "feelslike_c": 26.3,
          "feelslike_f": 79.3,
          "windchill_c": 28,
          "windchill_f": 82.4,
          "heatindex_c": 26.3,
          "heatindex_f": 79.3,
          "dewpoint_c": 5,
          "dewpoint_f": 41,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 14.1,
          "gust_kph": 22.7,
          "uv": 1
      },
      {
          "time_epoch": 1654817400,
          "time": "2022-06-10 05:00",
          "temp_c": 27.6,
          "temp_f": 81.7,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 5.8,
          "wind_kph": 9.4,
          "wind_degree": 69,
          "wind_dir": "ENE",
          "pressure_mb": 999,
          "pressure_in": 29.5,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 24,
          "cloud": 17,
          "feelslike_c": 26.1,
          "feelslike_f": 79,
          "windchill_c": 27.6,
          "windchill_f": 81.7,
          "heatindex_c": 26.1,
          "heatindex_f": 79,
          "dewpoint_c": 5.1,
          "dewpoint_f": 41.2,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 12.3,
          "gust_kph": 19.8,
          "uv": 7
      },
      {
          "time_epoch": 1654821000,
          "time": "2022-06-10 06:00",
          "temp_c": 29.9,
          "temp_f": 85.8,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 5.6,
          "wind_kph": 9,
          "wind_degree": 80,
          "wind_dir": "E",
          "pressure_mb": 1000,
          "pressure_in": 29.52,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 21,
          "cloud": 8,
          "feelslike_c": 27.8,
          "feelslike_f": 82,
          "windchill_c": 29.9,
          "windchill_f": 85.8,
          "heatindex_c": 27.8,
          "heatindex_f": 82,
          "dewpoint_c": 5.5,
          "dewpoint_f": 41.9,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 11.2,
          "gust_kph": 18,
          "uv": 7
      },
      {
          "time_epoch": 1654824600,
          "time": "2022-06-10 07:00",
          "temp_c": 34.4,
          "temp_f": 93.9,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 5.1,
          "wind_kph": 8.3,
          "wind_degree": 110,
          "wind_dir": "ESE",
          "pressure_mb": 1000,
          "pressure_in": 29.52,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 16,
          "cloud": 5,
          "feelslike_c": 32.5,
          "feelslike_f": 90.5,
          "windchill_c": 34.4,
          "windchill_f": 93.9,
          "heatindex_c": 32.5,
          "heatindex_f": 90.5,
          "dewpoint_c": 5.3,
          "dewpoint_f": 41.5,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 5.8,
          "gust_kph": 9.4,
          "uv": 8
      },
      {
          "time_epoch": 1654828200,
          "time": "2022-06-10 08:00",
          "temp_c": 37.5,
          "temp_f": 99.5,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 3.1,
          "wind_kph": 5,
          "wind_degree": 150,
          "wind_dir": "SSE",
          "pressure_mb": 999,
          "pressure_in": 29.51,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 13,
          "cloud": 4,
          "feelslike_c": 36.4,
          "feelslike_f": 97.5,
          "windchill_c": 37.5,
          "windchill_f": 99.5,
          "heatindex_c": 36.4,
          "heatindex_f": 97.5,
          "dewpoint_c": 4.7,
          "dewpoint_f": 40.5,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 3.6,
          "gust_kph": 5.8,
          "uv": 9
      },
      {
          "time_epoch": 1654831800,
          "time": "2022-06-10 09:00",
          "temp_c": 38.8,
          "temp_f": 101.8,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 4.9,
          "wind_kph": 7.9,
          "wind_degree": 236,
          "wind_dir": "WSW",
          "pressure_mb": 999,
          "pressure_in": 29.5,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 12,
          "cloud": 4,
          "feelslike_c": 38.2,
          "feelslike_f": 100.8,
          "windchill_c": 38.8,
          "windchill_f": 101.8,
          "heatindex_c": 38.2,
          "heatindex_f": 100.8,
          "dewpoint_c": 4.7,
          "dewpoint_f": 40.5,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 5.6,
          "gust_kph": 9,
          "uv": 9
      },
      {
          "time_epoch": 1654835400,
          "time": "2022-06-10 10:00",
          "temp_c": 40.2,
          "temp_f": 104.4,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 8.5,
          "wind_kph": 13.7,
          "wind_degree": 252,
          "wind_dir": "WSW",
          "pressure_mb": 999,
          "pressure_in": 29.49,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 11,
          "cloud": 4,
          "feelslike_c": 40.2,
          "feelslike_f": 104.4,
          "windchill_c": 40.2,
          "windchill_f": 104.4,
          "heatindex_c": 40.2,
          "heatindex_f": 104.4,
          "dewpoint_c": 4.6,
          "dewpoint_f": 40.3,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 9.8,
          "gust_kph": 15.8,
          "uv": 10
      },
      {
          "time_epoch": 1654839000,
          "time": "2022-06-10 11:00",
          "temp_c": 44.7,
          "temp_f": 112.5,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 10.1,
          "wind_kph": 16.2,
          "wind_degree": 260,
          "wind_dir": "W",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 10,
          "cloud": 3,
          "feelslike_c": 47.4,
          "feelslike_f": 117.3,
          "windchill_c": 44.7,
          "windchill_f": 112.5,
          "heatindex_c": 47.4,
          "heatindex_f": 117.3,
          "dewpoint_c": 6.7,
          "dewpoint_f": 44.1,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 11.6,
          "gust_kph": 18.7,
          "uv": 10
      },
      {
          "time_epoch": 1654842600,
          "time": "2022-06-10 12:00",
          "temp_c": 45.6,
          "temp_f": 114.1,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 10.1,
          "wind_kph": 16.2,
          "wind_degree": 264,
          "wind_dir": "W",
          "pressure_mb": 997,
          "pressure_in": 29.44,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 9,
          "cloud": 2,
          "feelslike_c": 49,
          "feelslike_f": 120.2,
          "windchill_c": 45.6,
          "windchill_f": 114.1,
          "heatindex_c": 49,
          "heatindex_f": 120.2,
          "dewpoint_c": 5.6,
          "dewpoint_f": 42.1,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 11.6,
          "gust_kph": 18.7,
          "uv": 11
      },
      {
          "time_epoch": 1654846200,
          "time": "2022-06-10 13:00",
          "temp_c": 44.6,
          "temp_f": 112.3,
          "is_day": 1,
          "condition": {
              "text": "Sunny",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/113.png",
              "code": 1000
          },
          "wind_mph": 10.7,
          "wind_kph": 17.3,
          "wind_degree": 268,
          "wind_dir": "W",
          "pressure_mb": 996,
          "pressure_in": 29.4,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 8,
          "cloud": 17,
          "feelslike_c": 47.3,
          "feelslike_f": 117.1,
          "windchill_c": 44.6,
          "windchill_f": 112.3,
          "heatindex_c": 47.3,
          "heatindex_f": 117.1,
          "dewpoint_c": 3.3,
          "dewpoint_f": 37.9,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 12.3,
          "gust_kph": 19.8,
          "uv": 10
      },
      {
          "time_epoch": 1654849800,
          "time": "2022-06-10 14:00",
          "temp_c": 44.3,
          "temp_f": 111.7,
          "is_day": 1,
          "condition": {
              "text": "Partly cloudy",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
              "code": 1003
          },
          "wind_mph": 13.6,
          "wind_kph": 22,
          "wind_degree": 267,
          "wind_dir": "W",
          "pressure_mb": 995,
          "pressure_in": 29.37,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 8,
          "cloud": 32,
          "feelslike_c": 46.7,
          "feelslike_f": 116.1,
          "windchill_c": 44.3,
          "windchill_f": 111.7,
          "heatindex_c": 46.7,
          "heatindex_f": 116.1,
          "dewpoint_c": 2.3,
          "dewpoint_f": 36.1,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 15.7,
          "gust_kph": 25.2,
          "uv": 10
      },
      {
          "time_epoch": 1654853400,
          "time": "2022-06-10 15:00",
          "temp_c": 44,
          "temp_f": 111.2,
          "is_day": 1,
          "condition": {
              "text": "Partly cloudy",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
              "code": 1003
          },
          "wind_mph": 15.9,
          "wind_kph": 25.6,
          "wind_degree": 267,
          "wind_dir": "W",
          "pressure_mb": 994,
          "pressure_in": 29.35,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 8,
          "cloud": 45,
          "feelslike_c": 46.2,
          "feelslike_f": 115.2,
          "windchill_c": 44,
          "windchill_f": 111.2,
          "heatindex_c": 46.2,
          "heatindex_f": 115.2,
          "dewpoint_c": 1.5,
          "dewpoint_f": 34.7,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 18.3,
          "gust_kph": 29.5,
          "uv": 10
      },
      {
          "time_epoch": 1654857000,
          "time": "2022-06-10 16:00",
          "temp_c": 43.5,
          "temp_f": 110.3,
          "is_day": 1,
          "condition": {
              "text": "Partly cloudy",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
              "code": 1003
          },
          "wind_mph": 15,
          "wind_kph": 24.1,
          "wind_degree": 270,
          "wind_dir": "W",
          "pressure_mb": 993,
          "pressure_in": 29.34,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 7,
          "cloud": 45,
          "feelslike_c": 45.4,
          "feelslike_f": 113.7,
          "windchill_c": 43.5,
          "windchill_f": 110.3,
          "heatindex_c": 45.4,
          "heatindex_f": 113.7,
          "dewpoint_c": 0.8,
          "dewpoint_f": 33.4,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 17.2,
          "gust_kph": 27.7,
          "uv": 10
      },
      {
          "time_epoch": 1654860600,
          "time": "2022-06-10 17:00",
          "temp_c": 41.6,
          "temp_f": 106.9,
          "is_day": 1,
          "condition": {
              "text": "Partly cloudy",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
              "code": 1003
          },
          "wind_mph": 14.5,
          "wind_kph": 23.4,
          "wind_degree": 260,
          "wind_dir": "W",
          "pressure_mb": 993,
          "pressure_in": 29.33,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 9,
          "cloud": 49,
          "feelslike_c": 42.3,
          "feelslike_f": 108.1,
          "windchill_c": 41.6,
          "windchill_f": 106.9,
          "heatindex_c": 42.3,
          "heatindex_f": 108.1,
          "dewpoint_c": 1.8,
          "dewpoint_f": 35.2,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 18.3,
          "gust_kph": 29.5,
          "uv": 10
      },
      {
          "time_epoch": 1654864200,
          "time": "2022-06-10 18:00",
          "temp_c": 37.4,
          "temp_f": 99.3,
          "is_day": 1,
          "condition": {
              "text": "Partly cloudy",
              "icon": "//cdn.weatherapi.com/weather/64x64/day/116.png",
              "code": 1003
          },
          "wind_mph": 12.5,
          "wind_kph": 20.2,
          "wind_degree": 259,
          "wind_dir": "W",
          "pressure_mb": 996,
          "pressure_in": 29.4,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 14,
          "cloud": 45,
          "feelslike_c": 36.2,
          "feelslike_f": 97.2,
          "windchill_c": 37.4,
          "windchill_f": 99.3,
          "heatindex_c": 36.2,
          "heatindex_f": 97.2,
          "dewpoint_c": 5.4,
          "dewpoint_f": 41.7,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 20.8,
          "gust_kph": 33.5,
          "uv": 9
      },
      {
          "time_epoch": 1654867800,
          "time": "2022-06-10 19:00",
          "temp_c": 36.1,
          "temp_f": 97,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 9.6,
          "wind_kph": 15.5,
          "wind_degree": 203,
          "wind_dir": "SSW",
          "pressure_mb": 996,
          "pressure_in": 29.42,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 15,
          "cloud": 21,
          "feelslike_c": 34.5,
          "feelslike_f": 94.1,
          "windchill_c": 36.1,
          "windchill_f": 97,
          "heatindex_c": 34.5,
          "heatindex_f": 94.1,
          "dewpoint_c": 5.3,
          "dewpoint_f": 41.5,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 17.4,
          "gust_kph": 28.1,
          "uv": 1
      },
      {
          "time_epoch": 1654871400,
          "time": "2022-06-10 20:00",
          "temp_c": 33,
          "temp_f": 91.4,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 3.4,
          "wind_kph": 5.4,
          "wind_degree": 187,
          "wind_dir": "S",
          "pressure_mb": 998,
          "pressure_in": 29.47,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 19,
          "cloud": 14,
          "feelslike_c": 30.9,
          "feelslike_f": 87.6,
          "windchill_c": 33,
          "windchill_f": 91.4,
          "heatindex_c": 30.9,
          "heatindex_f": 87.6,
          "dewpoint_c": 6.3,
          "dewpoint_f": 43.3,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 6.9,
          "gust_kph": 11.2,
          "uv": 1
      },
      {
          "time_epoch": 1654875000,
          "time": "2022-06-10 21:00",
          "temp_c": 31.6,
          "temp_f": 88.9,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 6.7,
          "wind_kph": 10.8,
          "wind_degree": 119,
          "wind_dir": "ESE",
          "pressure_mb": 999,
          "pressure_in": 29.49,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 21,
          "cloud": 3,
          "feelslike_c": 29.5,
          "feelslike_f": 85.1,
          "windchill_c": 31.6,
          "windchill_f": 88.9,
          "heatindex_c": 29.5,
          "heatindex_f": 85.1,
          "dewpoint_c": 6.7,
          "dewpoint_f": 44.1,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 14.1,
          "gust_kph": 22.7,
          "uv": 1
      },
      {
          "time_epoch": 1654878600,
          "time": "2022-06-10 22:00",
          "temp_c": 30.4,
          "temp_f": 86.7,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 5.8,
          "wind_kph": 9.4,
          "wind_degree": 126,
          "wind_dir": "SE",
          "pressure_mb": 999,
          "pressure_in": 29.49,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 23,
          "cloud": 10,
          "feelslike_c": 28.5,
          "feelslike_f": 83.3,
          "windchill_c": 30.4,
          "windchill_f": 86.7,
          "heatindex_c": 28.5,
          "heatindex_f": 83.3,
          "dewpoint_c": 6.7,
          "dewpoint_f": 44.1,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 12.3,
          "gust_kph": 19.8,
          "uv": 1
      },
      {
          "time_epoch": 1654882200,
          "time": "2022-06-10 23:00",
          "temp_c": 29.2,
          "temp_f": 84.6,
          "is_day": 0,
          "condition": {
              "text": "Clear",
              "icon": "//cdn.weatherapi.com/weather/64x64/night/113.png",
              "code": 1000
          },
          "wind_mph": 4,
          "wind_kph": 6.5,
          "wind_degree": 129,
          "wind_dir": "SE",
          "pressure_mb": 1000,
          "pressure_in": 29.52,
          "precip_mm": 0,
          "precip_in": 0,
          "humidity": 25,
          "cloud": 3,
          "feelslike_c": 27.5,
          "feelslike_f": 81.5,
          "windchill_c": 29.2,
          "windchill_f": 84.6,
          "heatindex_c": 27.5,
          "heatindex_f": 81.5,
          "dewpoint_c": 7,
          "dewpoint_f": 44.6,
          "will_it_rain": 0,
          "chance_of_rain": 0,
          "will_it_snow": 0,
          "chance_of_snow": 0,
          "vis_km": 10,
          "vis_miles": 6,
          "gust_mph": 8.5,
          "gust_kph": 13.7,
          "uv": 1
      }
  ]
}

const day3Reducer = (state = startingState, action) => {
  switch (action.type) {
    case "DAY3":
      return action.value;
    default:
      return state;
  }
};

export default day3Reducer;
